"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPublicProducts = exports.getPublicProduct = exports.getPublicProducts = exports.deleteProductRelation = exports.postProductRelation = exports.putProductOrganization = exports.putProductAccessibility = exports.deleteProductPermission = exports.postProductPermission = exports.putProductAction = exports.postProduct = exports.putProduct = exports.getProduct = exports.getProducts = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var productsAuthorizedPath = root_1.pimAuthorized + '/products/';
var productsPublicPath = root_1.pimPublic + '/products/';

var getProducts = function getProducts(authentication, queryParameters) {
  return common_1.get(authentication, productsAuthorizedPath, queryParameters);
};

exports.getProducts = getProducts;

var getProduct = function getProduct(authentication, id) {
  return common_1.get(authentication, productsAuthorizedPath + id);
};

exports.getProduct = getProduct;

var putProduct = function putProduct(authentication, product) {
  return common_1.put(authentication, productsAuthorizedPath + product.id, product);
};

exports.putProduct = putProduct;

var postProduct = function postProduct(authentication, product) {
  return common_1.post(authentication, productsAuthorizedPath, product);
};

exports.postProduct = postProduct;

var putProductAction = function putProductAction(authentication, id, action, data) {
  return common_1.putSub(authentication, productsAuthorizedPath, id, action, data);
};

exports.putProductAction = putProductAction;

var postProductPermission = function postProductPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, productsAuthorizedPath, id, permission);
};

exports.postProductPermission = postProductPermission;

var deleteProductPermission = function deleteProductPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, productsAuthorizedPath, id, permissionId);
};

exports.deleteProductPermission = deleteProductPermission;

var putProductAccessibility = function putProductAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, productsAuthorizedPath, id, accessibility);
};

exports.putProductAccessibility = putProductAccessibility;

var putProductOrganization = function putProductOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, productsAuthorizedPath, id, accessibility);
};

exports.putProductOrganization = putProductOrganization;

var postProductRelation = function postProductRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, productsAuthorizedPath, id, relation);
};

exports.postProductRelation = postProductRelation;

var deleteProductRelation = function deleteProductRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, productsAuthorizedPath, id, relationId);
};

exports.deleteProductRelation = deleteProductRelation;

var getPublicProducts = function getPublicProducts(authentication, queryParameters) {
  return common_1.get(authentication, productsPublicPath, queryParameters);
};

exports.getPublicProducts = getPublicProducts;

var getPublicProduct = function getPublicProduct(authentication, id) {
  return common_1.get(authentication, productsPublicPath + id);
};

exports.getPublicProduct = getPublicProduct;

var searchPublicProducts = function searchPublicProducts(authentication, queryParameters) {
  return common_1.get(authentication, productsPublicPath + 'search', queryParameters);
};

exports.searchPublicProducts = searchPublicProducts;